<template>
  <div>
    <tool
      :level="level"
      @add="addForm"
    />
    <export-tool
      v-if="permissions['form-export']"
      :count="selectedRowKeys.length"
      :total="dataList.length"
      @export="batchExport"
    />
    <div class="table_main">
      <a-table
        :columns="formColumns"
        :pagination="false"
        :loading="loading"
        :data-source="dataList"
        :row-selection="permissions['form-export'] ? {selectedRowKeys: selectedRowKeys, onChange: onSelectChange} : null"
        @change="onChange"
      >
        <div
          slot="name"
          slot-scope="text, record"
          class="table_name"
        >
          <a-tooltip
            overlay-class-name="smart-name-tip"
            placement="top"
          >
            <template slot="title">
              {{ text }}
            </template>
            {{ text }}
          </a-tooltip>
          <p>
            <table-tag :status="record.status" />
            <span
              class="form_type"
              v-text="formType[record.type]"
            />
          </p>
        </div>

        <div
          slot="remark"
          slot-scope="text, record"
          class="table_remark"
          @click="toRemark(record)"
        >
          <p
            v-if="formatText(text) !== '--'"
            class="remark_content"
            v-text="formatText(text)"
          />
          <i class="iconfont iconicon-test66" />
        </div>
        <p
          slot="view"
          slot-scope="text"
          v-text="formatText(text)"
        />
        <div
          slot="uptime"
          slot-scope="text"
          style="width: 80px;"
        >
          <div class="table_time">
            <p class="time_date">
              {{ formatUpTime(text, 1) }}
            </p>
            <p
              v-if="text"
              class="time_division"
            >
              {{ formatUpTime(text, 2) }}
            </p>
          </div>
        </div>
        <div
          slot="username"
          slot-scope="text, record, index"
          style="max-width: 140px;"
        >
          <!-- v-if="level !== 0" -->
          <div
            class="table_time"
          >
            <p :class="['time_date', formatDeveloper(record) === '--' ? 'font_normal' : '']">
              <other-tooltip
                col-key="username"
                :text="text || '--'"
                :index="index"
                :columns="formColumns"
              />
            </p>

            <p
              v-if="formatDeveloper(record) !== '--'"
              class="time_division developer"
            >
              {{ formatDeveloper(record) }}
            </p>
          </div>
          <!-- <div
            v-else
            class="table_time"
          >
            <p class="time_date font_normal">
              {{ formatDeveloper(record) }}
            </p>
          </div> -->
        </div>
        <span
          slot="post_times"
          slot-scope="text"
          style="width: 80px;"
        >
          <!-- @click="toSubmitTab(record)" -->
          <span
            class="sub_record"
            v-text="text"
          />
        </span>
        <span
          slot="action"
          slot-scope="text, record"
          class="action"
        >
          <a-popover placement="bottom">
            <template slot="content">
              <ul class="action_list">
                <li @click.stop="toEdit(record)">{{ $t('message["36"]') }}</li>
                <li
                  @click.stop="copyForm(record)"
                >{{ $t('message["318"]') }}</li>
                <li @click.stop="switchForm(record)">{{ formSwitch[record.status] }}</li>
                <!-- <li @click.stop="toSubmitTab(record)">查看提交记录</li> -->
                <li
                  v-if="permissions['form-export']"
                  @click.stop="toExportSingle(record)"
                >{{ $t('message["189"]') }}</li>
                <li
                  v-if="record.type === 1"
                  @click.stop="copyAddress(record, 'code')"
                >{{ $t('message["322"]') }}</li>
                <li
                  v-if="record.type === 2"
                  @click.stop="copyAddress(record, 'address')"
                >{{ $t('message["323"]') }}</li>
                <li @click.stop="deleteCurrentForm(record)">{{ $t('message["962"]') }}</li>
              </ul>
            </template>
            <p class="action_link">{{ $t('message["377"]') }}<i class="iconfont iconicon-test19" /></p>
          </a-popover>
        </span>
      </a-table>
      <pagination
        v-if="formList.length > 0"
        ref="pagination"
        :pagination="pagination"
        @change="handlePage"
      />
    </div>
    <!-- 复制地址 -->
    <copy-modal
      :visible="visibleCopyAddress"
      :tip="copyhTip"
      url="https://help.westartrack.com/faq/d_5da975ad4db67f2b34706f3c.html"
      @close="visibleCopyAddress = false"
    >
      <div slot="content">
        <div class="content">
          <p v-text="copyContent" />
        </div>
        <div class="footer">
          <a-button
            v-copy="copyContent"
            type="primary"
            @click="toCopy"
          >
            {{ $t('message["318"]') }}
          </a-button>
          <span
            v-if="visibleCopySuccess"
            class="copy_success"
          ><i class="iconfont iconicon-test70" />{{ $t('message["321"]') }}</span>
        </div>
      </div>
    </copy-modal>
    <!-- 复制代码 -->
    <copy-modal
      :visible="visibleCopyCode"
      :title="copyTitTxt"
      :tip="copyTipCont"
      url="https://help.westartrack.com/faq/d_5da96aab4db67f333e5ef8a3.html"
      @close="visibleCopyCode = false"
    >
      <div slot="content">
        <div slot="content">
          <div class="content">
            <p v-text="copyContent" />
          </div>
          <div class="footer">
            <a-button
              v-copy="copyContent"
              type="primary"
              @click="toCopy"
            >
              {{ $t('message["318"]') }}
            </a-button>
            <span
              v-if="visibleCopySuccess"
              class="copy_success"
            ><i class="iconfont iconicon-test70" />{{ $t('message["321"]') }}</span>
          </div>
        </div>
      </div>
    </copy-modal>
    <!-- 备注 -->
    <copy-modal
      :visible.sync="visibleNote"
      :title="remarkTxt"
      :tip="remarkTipTxt"
      :help="false"
      @close="visibleNote = false"
    >
      <div slot="content">
        <a-textarea
          v-model="oRemark.remark"
          class="note_textarea"
          :placeholder="remarkConPlace"
        />
        <div class="footer">
          <a-button
            type="primary"
            @click.stop="submitRemark"
          >
            {{ $t('message["915"]') }}
          </a-button>
          <a-button @click="visibleNote = false">
            {{ $t('message["896"]') }}
          </a-button>
        </div>
      </div>
    </copy-modal>
    <!-- 停用自定义弹窗 -->
    <!-- 导出记录弹框 -->
    <a-modal
      :title="setExportTit"
      :visible="exportVisible"
      wrap-class-name="export_modal"
      :destroy-on-close="true"
      @ok="toExport"
      @cancel="onExportClose"
    >
      <a-form :form="exportForm">
        <a-form-item :label="`${subTimeTit}：`">
          <div class="picker">
            <a-range-picker v-decorator="['range_date']" />
          </div>
        </a-form-item>
        <a-form-item :label="`${statusTit}：`">
          <a-select
            v-decorator="[
              'status'
            ]"
            :placeholder="selectPlaceholder"
          >
            <template v-for="item in statusSelect">
              <a-select-option
                :key="item.value"
                :value="item.value"
              >
                {{ item.name }}
              </a-select-option>
            </template>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script type="text/ecmascript-6">
import TableTag from './components/TableTag'
import OtherTooltip from './components/OtherTooltip'
import Pagination from '@/components/pc/Pagination'
import copyModal from './components/Modal'
import Tool from './components/Tool'
import ExportTool from './components/ManageExportBtn'
import { copy } from '@/lib/directives'
import { mapState, mapActions, mapMutations } from 'vuex'
import { formatUpTime, formatDeveloper, calculateRate } from './common'

const EXPORT_STATUS = 3
export default {
  directives: { copy },
  components: {
    Tool,
    TableTag,
    copyModal,
    Pagination,
    ExportTool,
    OtherTooltip
  },
  props: {
    level: {
      type: Number,
      default: 3
    },
    permissions: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      visibleCopyAddress: false, // 复制地址弹框
      visibleCopySuccess: false, // 复制地址成功与否
      visibleCopyCode: false, // 复制代码弹框
      visibleNote: false,
      oRemark: {},
      copyContent: '', // 复制的内容
      exportVisible: false, // 导出记录条件弹框
      exportForm: this.$form.createForm(this, { name: 'export' }),
      exportParams: {},
      selectedRowKeys: []
    }
  },
  computed: {
    ...mapState('smart/manage', ['loading', 'statusSelect', 'formList', 'formColumns', 'formType', 'formSwitch', 'pagination']),
    // 给表单数据添加key
    dataList () {
      return this.formList.map(item => {
        item.key = item.formid
        item.sub_rate = calculateRate(item.post_times, item.view_times)
        return item
      })
    },
    remarkTxt () {
      return this.$t('message["27"]')
    },
    copyTitTxt () {
      return this.$t('message["322"]')
    },
    copyTipCont () {
      return this.$t('message["327"]')
    },
    copyhTip () {
      return this.$t('message["490"]')
    },
    remarkTipTxt () {
      return this.$t('message["572"]')
    },
    remarkConPlace () {
      return this.$t('message["758"]')
    },
    selectPlaceholder () {
      return this.$t('message["855"]')
    },
    setExportTit () {
      return this.$t('message["1013"]')
    },
    delTips () {
      return this.$t('message["971"]').split('|')
    },
    subTimeTit () {
      return this.$t('message["1170"]')
    },
    statusTit () {
      return this.$t('message["1646"]')
    },
    stopTips () {
      return this.$t('message["1203"]').split('|')
    }
  },
  mounted () {
    this.getFormList()
    this.$bus.$on('clearSelectedRowKeys', this.clearSelectedRowKeys)
  },
  destroyed () {
    this.SET_PAGINATION({ key: 'currentPage', value: 1 })
  },
  methods: {
    ...mapActions('smart/manage', [
      'fetchFormList',
      'toFormSwitch',
      'setRemark',
      'toCopyData',
      'toCopyForm',
      'delForm',
      'exportSingleRecord'
    ]),
    ...mapMutations('smart/manage', ['SET_PAGINATION']),
    ...mapMutations('smart/submit', ['SET_SUB_QUERY']),
    formatDeveloper,
    formatUpTime,
    // 请求数据
    async getFormList (obj = {}) {
      let params = {
        tab: 'formManageMent',
        page: this.pagination.currentPage,
        limit: this.pagination.pageSizesType[this.pagination.pageSize],
        ...obj
      }
      await this.fetchFormList(params)
      this.$router.push({ query: params })
    },
    clearSelectedRowKeys () {
      this.selectedRowKeys = []
    },
    formatText (text) {
      if (text === 0 || text === '') {
        return '--'
      } else {
        return text
      }
    },
    switchForm (info) {
      const { status } = info
      const _this = this
      if (status !== 2) {
        this.$confirm({
          iconType: 'info-circle',
          title: this.$t('message["918"]') + '？',
          content: <div>{ this.stopTips[0]}<span class="confitm_warning">{ this.stopTips[1]}</span>，<p>{ this.stopTips[2]}？</p></div>,
          okText: this.$t('message["466"]'),
          cancelText: this.$t('message["896"]'),
          closable: true,
          onOk: () => {
            _this.toSwithForm(info)
          }
        })
      } else {
        // console.log('启用')
        _this.toSwithForm(info)
      }
    },
    async toSwithForm (params) {
      const { formid, status } = params
      const messageText = this.formSwitch[status]
      const chain = await this.toFormSwitch({ formid })
      chain.onSuccess(res => {
        this.getFormList()
        this.$message.success(`${messageText}成功`)
      })
        .fetch()
    },
    toCopy () {
      this.visibleCopySuccess = true
      let timer = setInterval(() => {
        this.visibleCopySuccess = false
        clearInterval(timer)
      }, 3000)
    },
    // 复制表单
    async copyForm (info) {
      const { formid } = info
      const _this = this
      const chain = await this.toCopyForm()
      chain.params({ formid })
        .onSuccess(res => {
          _this.$message.success(this.$t('message["320"]'))
          // 复制成功，重新请求接口
          _this.getFormList()
        })
        .fetch()
    },
    async submitRemark () {
      await this.setRemark(this.oRemark)
      this.$set(this._data, 'visibleNote', false)
    },
    toRemark (value) {
      const { formid, remark } = value
      this.$set(this._data, 'oRemark', { formid, remark })
      this.$set(this._data, 'visibleNote', true)
    },
    async copyAddress (info, type = 'code') {
      const { formid } = info
      const chain = await this.toCopyData()
      const _this = this
      chain.params({ formid })
        .onSuccess(res => {
          _this.$set(this._data, 'copyContent', res.content)
          if (type === 'code') {
            _this.$set(this._data, 'visibleCopyCode', true)
          } else if (type === 'address') {
            _this.$set(this._data, 'visibleCopyAddress', true)
          }
        })
        .fetch()
    },
    resetFetchList (info = {}) {
      const { currentPage, pageSize } = info
      // 请求数据
      this.getFormList({
        ...this.$route.query,
        page: currentPage,
        limit: this.pagination.pageSizesType[pageSize]
      })
    },
    // 分页触发
    handlePage (pagination) {
      const { currentPage, pageSize } = pagination
      this.SET_PAGINATION({ key: 'currentPage', value: currentPage })
      this.resetFetchList({ currentPage, pageSize })
      this.selectedRowKeys = []
    },
    // 删除表单
    deleteCurrentForm (info) {
      const _this = this
      const { formid } = info
      this.$confirm({
        iconType: 'info-circle',
        title: this.$t('message["923"]') + '？',
        content: <div>{ this.delTips[0]}<span class="confitm_warning">{ this.delTips[1]}</span>，<p>{ this.delTips[2]}？</p></div>,
        okText: this.$t('message["466"]'),
        cancelText: this.$t('message["896"]'),
        closable: true,
        onOk: () => {
          _this.delFormItem(formid)
        }
      })
    },
    async delFormItem (formid) {
      const chain = await this.delForm()
      const _this = this
      chain.params({ formid })
        .onSuccess(res => {
          _this.$message.success(this.$t('message["965"]'))
        })
        .onNetComplete(() => {
          _this.getFormList()
        })
        .fetch()
    },
    // 导出提交记录并下载
    toExportSingle (info) {
      const { formid } = info
      this.exportVisible = true
      this.exportParams = Object.assign({}, { formid })
    },
    // 准备导出的参数
    parpaerExportParams (value) {
      let params = Object.assign({}, this.exportParams)
      for (let key in value) {
        if (key === 'range_date' && typeof value[key] !== 'undefined') {
          if (value[key].length > 0) {
            params['start_time'] = value[key][0].format('YYYY-MM-DD')
            params['end_time'] = value[key][1].format('YYYY-MM-DD')
          } else {
            delete params['start_time']
            delete params['end_time']
          }
        }
        if (key === 'status') {
          params[key] = (typeof value[key] === 'undefined') ? EXPORT_STATUS : value[key]
        }
      }
      return params
    },
    toExport () {
      let value = this.exportForm.getFieldsValue()
      let params = this.parpaerExportParams(value)
      this.fetchExport(params)
    },
    async fetchExport (params) {
      const _this = this
      const chain = await this.exportSingleRecord()
      chain.params(params)
        .onSuccess((res, all, header) => {
          const { baseURL } = header.config
          const { url } = res
          console.log(res)
          let downloadUrl = baseURL + url
          window.location.href = downloadUrl
          _this.exportVisible = false
        })
        .fetch()
    },
    onExportClose () {
      this.exportForm.resetFields()
      this.exportVisible = false
    },
    // 分页、过滤、排序触发
    onChange (pagination, filters, sorter) {
      let params = Object.assign({}, { sortkey: '' }, { sorttype: 0 })
      if (sorter.order) {
        const { order } = sorter
        let sort = 0
        const orderTable = { 'ascend': 1, 'descend': 2 }
        sort = orderTable[order]
        params = Object.assign(params, { sortkey: sorter.columnKey }, { sorttype: sort })
      }
      this.getFormList({
        ...this.$route.query,
        page: pagination.currentPage,
        limit: pagination.pageSize,
        ...params
      })
    },
    // 编辑表单
    toEdit (record) {
      const { formid, type } = record
      this.$router.push({
        name: Number(type) === 1 ? 'universalForm' : 'UniversalOutsideForm',
        query: {
          type,
          formid
        }
      })
    },
    // 添加表单
    addForm (info) {
      const { type } = info
      this.$router.push({
        name: Number(type) === 1 ? 'universalForm' : 'UniversalOutsideForm',
        query: {
          type,
          formid: 0
        }
      })
    },
    // 查看提交记录
    /* toSubmitTab (info) {
      const { formid } = info
      this.SET_SUB_QUERY({ formid })
      this.$router.push({ query: { tab: 'subRecord', formid } })
      this.$emit('sub', { tab: 'subRecord' })
    }, */
    onSelectChange (value) {
      this.selectedRowKeys = value
      // console.log(value)
    },
    // 批量导出提交记录
    batchExport () {
      let formids = this.selectedRowKeys.join(',')
      this.exportVisible = true
      this.exportParams = Object.assign({}, { formid: formids })
    }
  }
}
</script>

<style scoped lang="scss">
.form_type {
  color: $gray3;
  font-size: 12px;
  margin: 0 4px;
}
.table_main::v-deep {
  .ant-checkbox-wrapper {
    margin-bottom: 0;
  }
}
/* .sub_record {
  color: $info-color;
}
.sub_record:hover {
  cursor: pointer;
} */
.action_link {
  color: $primary-color;
  margin-right: 4px;
}
.action_link:hover {
  cursor: pointer;
}
.table_name {
  width: 120px;
  font-size: 12px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.table_time {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  .time_division,
  .time_date {
    font-size: 12px;
    line-height: 16px;
  }
  .developer {
    margin-top: 4px;
  }
  .time_division {
    color: $gray;
  }
  .font_normal {
    font-size: 14px;
    color: #333;
  }
}
.action_list {
  li {
    line-height: 24px;
    padding: 4px 12px;
  }
  li:hover {
    cursor: pointer;
    background: #f4f7f9;
    border-radius: 4px;
  }
}
.content {
  background: #f7f7f7;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  p {
    margin: 4px 12px;
  }
}
.footer {
  margin: 24px 0 0 0;
  .copy_success {
    .iconfont {
      color: #42c27e;
      font-size: 16px;
      margin: 0 4px;
      vertical-align: middle;
    }
  }
}
.table_remark {
  max-width: 120px;
  display: flex;
  flex-direction: row;
  .remark_content {
    max-width: 120px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .iconfont {
    display: inline;
    color: #ebebeb;
    margin-left: 8px;
  }
}
.table_remark:hover {
  cursor: pointer;
}
.note_textarea {
  width: 100%;
  height: 224px;
  border-radius: 4px;
  resize: none;
}
.confitm_warning {
  color: $danger-color;
}
</style>
<style lang="scss">
.export_modal {
  .picker {
    width: 320px;
  }
  form {
    width: 406px;
    margin: 0 auto;
  }
  .ant-form-item-label {
    width: 70px;
    text-align: right;
  }
  .ant-form-item-control-wrapper {
    display: inline-block;
    float: right;
  }
}
</style>
<style lang="scss">
  .smart-name-tip {
  .ant-tooltip-content {
    .ant-tooltip-arrow{
      display: none;
    }
  }
}
</style>
